import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Button, Spinner, Tabs, Tab } from "react-bootstrap";
import * as _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxOpen,
  faBoxes,
  faChevronRight,
  faBoxesStacked,
  faHandHoldingDollar,
  faDollar,
} from "@fortawesome/free-solid-svg-icons";
import { HashLoader } from "react-spinners";
import { Helmet } from "react-helmet";
import moment from "moment";
import { useLazyQuery, useQuery } from "@apollo/client";
import { COLOR_APP, COLOR_TEXT, SHOPID } from "../../constants";
import OrderBar from "./OrderBar";
import OrderData from "./OrderData";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { IconContext } from "react-icons";
import "../../layouts/navbar.css";
import { GET_DASHBOARD, GET_NEW_DASHBOARD } from "../../graphql/dashboard/query";
import AnimationLoading from "../../components/AnimationLoading";
import Notice from "../../components/Notice";
import { convertCurrentDate, moneyCurrency } from "../../helpers";
import TitleUpdater from "../../components/TitleUpdater";
import CurrentDateModal from "../../components/currentComponent/CurrentDateModal";
import { MdDateRange } from "react-icons/md";
import OrderCharts from "./OrderCharts";
import LoadingSpinner from "../../components/LoadingSpinner";
import { REPORT_STOCKS } from "../../graphql/stock/query";
import SoldProductsData from "./SoldProductsData";

function Dashboard({ location, history }) {
  const { height, width } = useWindowDimensions();

  const [shopData, setShopData] = useState([]);
  const SHOP_ID = localStorage.getItem("SHOP");

  // default this month
  let defaultStartMonth = moment().startOf("month").format("YYYY-MM-DD");
  let defaultEndMonth = moment().endOf("month").format("YYYY-MM-DD");

  // dashboard state
  const [totalPrice, setTotalPrice] = useState(0);
  const [goodProducts, setGoodProducts] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalStocks, setTotalStocks] = useState(0);
  const [time, setTime] = useState();
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: defaultStartMonth,
    createdAt_lt: defaultEndMonth,
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [dataBar, setDataBar] = useState()
  // const [dataCards, setDataCards] = useState

  const [getReports, { data: loadReports, loading: loadingReport }] = useLazyQuery(GET_NEW_DASHBOARD, {
    fetchPolicy: "cache-and-network",
  });

  const [soldProducts, setSoldProducts] = useState([]);
  const [getSoldReports, { data: soldReports, loading: loadingSold }] = useLazyQuery(REPORT_STOCKS, {
    fetchPolicy: "cache-and-network",
  });


  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("SHOP_DATA"));
    const SHOP_ID = localStorage.getItem("SHOP");
    if (items) {
      setShopData(items);
    }

    // _fetchDatashboard(SHOP_ID);
  }, []);

  useEffect(() => {

    _fetchReports()
  }, [SHOP_ID, cdFillter, activeButton])

  useEffect(() => {
    if (loadReports) {
      setDataBar(loadReports?.getDashboard)
      setGoodProducts(loadReports?.getDashboard?.goodProduct);
      setTotalOrders(loadReports?.getDashboard?.totalOrder);
      setTotalStocks(loadReports?.getDashboard?.totalStock);
      setTotalPrice(loadReports?.getDashboard?.totalPrice);
    }
  }, [loadReports]);

  useEffect(() => {
    if (soldReports) {
      setSoldProducts(soldReports?.stockSalesReport);
    }
  }, [soldReports]);

  const _fetchReports = async () => {
    try {

      let _where = {
        shop: SHOP_ID,
        format: true,
        tag: "DAY"

      }

      const splitDateTime = (dateString) => {
        const date = new Date(dateString);
        const datePart = date.toISOString().split('T')[0];
        const timePart = date.toISOString().split('T')[1].split('.')[0];
        return datePart;
      };



      if (!_.isEmpty(cdFillter)) {
        let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
        let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);

        _where = {
          ..._where,
          startDate: startDateComponents,
          endDate: endDateComponents,
          tag: "DAY"
        }
      }

      if (!_.isEmpty(activeButton)) {

        let _day = "";

        if (activeButton === "thisWeek") {
          _day = "WEEK";
        } else if (activeButton === "thisMonth") {
          _day = "MONTH";
        } else if (activeButton === "thisYear") {
          _day = "YEAR";
        } else {
          _day = "DAY"
        }

        _where = {
          ..._where,
          tag: _day
        }
      }

      await getReports({
        variables: {
          where: _where
        }
      })

      await getSoldReports({
        variables: {
          shopId: SHOP_ID
        }
      })


    } catch (error) {
      console.log(error)
    }
  }




  return (
    <div className={width > 700 ? "pt-2" : "pt-4"}>

      <TitleUpdater title={shopData?.name} />
      {/* {loading && !dashboardDatas?.dashboard && <AnimationLoading />} */}

      <div>

        <Row>
          <Col md={5} sm={12}>
            <div
              style={{
                width: "100%",
                marginBottom: "40px",
                display: 'flex', flexDirection: 'column'
              }}>

              <div className="d-flex justify-content-between align-items-center pl-2 pb-2">
                <h3 style={{ fontWeight: "bold", width: 200 }}>ພາບລວມ</h3>

                <Button
                  variant="outline-secondary"
                  onClick={() => setIsCurrentModals(true)}
                  style={{ width: "100%", maxWidth: 240, display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

                >
                  {loadingReport ? <Spinner size="sm" /> :
                    <MdDateRange style={{ fontSize: 25 }} />
                  }

                  {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                    "mm/dd/yyyy"
                  ) : (
                    <>
                      {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                    </>
                  )}
                </Button>
              </div>

              <Table style={{ background: "#fff" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "84px" }}>ຊື່ຮ້ານ:</td>
                    <td> {shopData.name} </td>
                  </tr>
                  <tr>
                    <td style={{ width: "180px" }}>ຮູບແບບ Package: </td>
                    <td>
                      <p id="cart-payment"> {shopData?.paymentType}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "180px" }}>
                      {shopData?.paymentType === "POINT"
                        ? "ຈໍານວນພ້ອຍປັດຈຸບັນ: "
                        : "ໄລຍະເວລາ: "}
                    </td>
                    {shopData?.paymentType === "POINT" ? (
                      <td>{moneyCurrency(shopData?.point)}</td>
                    ) : (
                      <td>
                        {moment(shopData.startDate).format("DD/MM/YYYY")} ~{" "}
                        {moment(shopData.endDate).format("DD/MM/YYYY")}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td style={{ color: COLOR_TEXT, fontSize: "24px" }}>
                      ຍອດມື້ນີ້:{" "}
                    </td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          color: "red",
                        }}>
                        ຍອດຂາຍ
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.balance?.price
                          )}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.balance?.priceBaht
                          )}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.balance?.priceUsd
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          margin: "0px 10px",
                          flexDirection: "column",
                        }}>
                        ຕົ້ນທືນ
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.cost?.price
                          )}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.cost?.priceBaht
                          )}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.cost?.priceUsd
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          color: "green",
                        }}>
                        ກໍາໄລ
                        <div id="cart-payment">
                          {moneyCurrency(dataBar?.balanceCurrentDate?.profit?.price) + " ກີບ"}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.profit?.priceBaht
                          ) + " ບາດ"}
                        </div>
                        <div id="cart-payment">
                          {moneyCurrency(
                            dataBar?.balanceCurrentDate?.profit?.priceUsd
                          ) + " ໂດລາ"}
                        </div>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </Table>
              <div style={{
                width: "100%",
                textAlign: "center",
              }}>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}>
                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: 18,
                          marginTop: 10,
                        }}>
                        <div>{moneyCurrency(dataBar?.balance?.balance?.price) + " ກີບ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.balance?.priceBaht) + " ບາດ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.balance?.priceUsd) + " ໂດລາ"}</div>
                      </div>
                    </div>{" "}
                    <p className="ml-4">ຍອດຂາຍ</p>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: 18,
                          marginTop: 10,
                        }}>
                        <div>{moneyCurrency(dataBar?.balance?.profit?.price) + " ກີບ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.profit?.priceBaht) + " ບາດ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.profit?.priceUsd) + " ໂດລາ"}</div>
                      </div>
                    </div>{" "}
                    <p>ຍອດກໍາໄລ</p>
                  </div>
                </div>



                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}>
                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faDollar}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: 18,
                          marginTop: 10,
                        }}>
                        <div>{moneyCurrency(dataBar?.balance?.cost?.price) + " ກີບ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.cost?.priceBaht) + " ບາດ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.cost?.priceUsd) + " ໂດລາ"}</div>
                      </div>
                    </div>{" "}
                    <p className="ml-4">ຍອດຕົ້ນທືນ  </p>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faBoxesStacked}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <p style={{ fontSize: 18, marginTop: 10 }}>
                        {moneyCurrency(totalOrders)}
                      </p>
                    </div>{" "}
                    <p className="ml-4">ອໍເດີ້ທັງໝົດ</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}>
                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <p style={{ fontSize: 18, marginTop: 10 }}>
                        {moneyCurrency(totalPrice)}
                      </p>
                    </div>{" "}
                    <p>ຍອດເງິນທັງໝົດ</p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faBoxOpen}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <p style={{ fontSize: 18, marginTop: 10 }}>
                        {moneyCurrency(totalStocks)}
                      </p>
                    </div>{" "}
                    <p className="ml-4">ສິນຄ້າທັງໝົດ</p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 5

                  }}>
                  <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",

                      }}>
                      <FontAwesomeIcon
                        icon={faBoxOpen}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: 18,
                          marginTop: 10,
                        }}>
                        <div>ອໍເດີ້ທີ່ເປັນ ກີບ: {moneyCurrency(dataBar?.balance?.amount?.amount) + " ອັນ"}</div>
                        <div>ອໍເດີ້ທີ່ເປັນ ບາດ: {moneyCurrency(dataBar?.balance?.amount?.amountBaht) + " ອັນ"}</div>
                        <div>ອໍເດີ້ທີ່ເປັນ ໂດລາ: {moneyCurrency(dataBar?.balance?.amount?.amountUsd) + " ອັນ"}</div>
                      </div>
                    </div>{" "}
                    <p className="ml-4">ຈຳນວນສະຕ໋ອກຕາມສະກຸນເງິນ</p>
                  </div>

                  {/* <div
                    style={{
                      width: "100%",
                      height: "162px",
                      background: "#fff",
                      border: "0.5px solid #CAD4DE",
                      overflow: "hidden",
                      borderRdius: "6px",
                      color: "#000",
                      padding: "27px",
                      marginLeft: "4px",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                      }}>
                      <FontAwesomeIcon
                        icon={faHandHoldingDollar}
                        style={{
                          marginRight: "5px",
                          fontSize: "36px",
                          margin: 10,
                          color: COLOR_TEXT,
                          borderRadius: 5,
                        }}
                      />{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: 18,
                          marginTop: 10,
                        }}>
                        <div>{moneyCurrency(dataBar?.balance?.amount?.amount) + " ອັນ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.amount?.amountBaht) + " ອັນ"}</div>
                        <div>{moneyCurrency(dataBar?.balance?.amount?.amountUsd) + " ອັນ"}</div>
                      </div>
                    </div>{" "}
                    <p>ລາຄາຂາຍ</p>
                  </div> */}
                </div>
              </div>


            </div>
          </Col>
          <Col md={7} sm={12}>
            {loadingReport ? <LoadingSpinner /> :
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: 5
                }}>
                <div
                  style={{
                    background: "#F4F6F8",
                  }}>

                  <OrderCharts data={dataBar} />

                </div>
                <div style={{ marginTop: 10 }}>
                  <Tabs defaultActiveKey="good" id="dashboard-tabs" className="mb-3">
                    <Tab eventKey="good" title="ສິນຄ້າຂາຍດີ(10ອັນດັບ)">
                      <OrderData goodProducts={goodProducts} />
                    </Tab>
                    <Tab eventKey="sold" title="ສິນຄ້າທີ່ຂายໄປ">
                      {loadingSold ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                          <LoadingSpinner />
                        </div>
                      ) : (
                        <SoldProductsData soldProducts={soldProducts} />
                      )}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            }
          </Col>
        </Row>

      </div>


      {/* current modal */}
      <CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}

      />
    </div>
  );
}

export default Dashboard;
